import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    FormUpdateInput,
    UpdateMultiPageForm as UpdateMultiPageFormMutation,
    UpdateMultiPageFormVariables,
} from 'nutshell-graphql-types';

import UPDATE_MULTI_PAGE_FORM from '../mutations/update-multi-page-form.graphql';

export function useUpdateMultiPageForm(): {
    updateMultiPageForm: (input: FormUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateMultiPageForm, {loading, error}] = useMutation<
        UpdateMultiPageFormMutation,
        UpdateMultiPageFormVariables
    >(UPDATE_MULTI_PAGE_FORM);

    return {
        updateMultiPageForm: (input: FormUpdateInput) => {
            return updateMultiPageForm({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
